@if (!hidden) {
  <mat-form-field
    [color]="color"
    [appearance]="appearance"
    [floatLabel]="floatLabel"
    [subscriptSizing]="hideSubscriptWrapper ? 'dynamic' : 'fixed'">
    @if (label && showLabel) {
      <mat-label>{{label}}</mat-label>
    }
    <mat-select
      [multiple]="multiple"
      [formControl]="control"
      [compareWith]="compareWith"
      [placeholder]="placeholder"
      [required]="required"
      panelClass="filter-select-panel filter-select-panel--search"
      [matTooltip]="tooltip()"
      [matTooltipClass]="'field-tooltip'"
      [matTooltipPosition]="toolTipPosition"
      (selectionChange)="onSelectionChange()">
      @if (multiple) {
        <mat-select-trigger>{{ summary() }}</mat-select-trigger>
      }

      <mat-option>
        <ngx-mat-select-search
          placeholderLabel="Search"
          [noEntriesFoundLabel]="noEntriesFoundLabel"
          [id]="'filter-' + controlName"
          [formControl]="filterControl"
          [showToggleAllCheckbox]="multiple"
          [toggleAllCheckboxChecked]="allToggled()"
          [toggleAllCheckboxIndeterminate]="indeterminate()"
          (toggleAll)="onToggleAll($event)"></ngx-mat-select-search>
      </mat-option>

      @for (option of filteredOptions; track $any(option)[idField]) {
        <mat-option
          [value]="option"
          [matTooltip]="$any(option)[labelField]"
          [matTooltipClass]="'field-tooltip'"
          [matTooltipPosition]="'left'">
          {{ $any(option)[labelField] }}
        </mat-option>
      }

      @if (noneEnabled) {
        <mat-option class="filter-search-select__none" [value]="noneOption">None</mat-option>
      }
    </mat-select>

    @if (control.hasError('required')) {
      <mat-error>{{label || 'Field'}} <strong>required</strong></mat-error>
    }
  </mat-form-field>
}
